import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=16815139&"
import script from "./FeedbackForm.vue?vue&type=script&lang=js&"
export * from "./FeedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports